module.exports = __webpack_public_path__ + "img/matrix.4777df32.gif";